import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import RoadworthyAnalytics from '@/components/roadworthy/RoadworthyAnalytics';
import RoadworthyRecords from '@/components/roadworthy/RoadworthyRecords';

export default function Roadworthy() {
  return (
    <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
      <div className="mb-8">
        <h1 className="text-4xl font-semibold tracking-tight mb-2">Roadworthy</h1>
        <p className="text-muted-foreground">Track vehicle roadworthy certificates and expiry dates.</p>
      </div>

      <Tabs defaultValue="analytics" className="space-y-6">
        <TabsList>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
          <TabsTrigger value="records">Records</TabsTrigger>
        </TabsList>

        <TabsContent value="analytics">
          <RoadworthyAnalytics />
        </TabsContent>

        <TabsContent value="records">
          <RoadworthyRecords />
        </TabsContent>
      </Tabs>
    </div>
  );
}
